import React from 'react';
import styled from 'styled-components';

interface SubscriptionBadgeProps {
  status: string;
  currentPeriodEnd: string;
  cancelAtPeriodEnd: boolean;
}

const SubscriptionBadge: React.FC<SubscriptionBadgeProps> = ({ status, currentPeriodEnd, cancelAtPeriodEnd }) => {

  if (!status) return null;

  const formatDateToDayMonth = (isoString: string) => {
    const date = new Date(isoString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
    });
  };

  const renderBadge = () => {
    switch (status) {
      case "TRIALING":
        return <GreenBadge>Trial</GreenBadge>;

      case "ACTIVE":
        return cancelAtPeriodEnd && currentPeriodEnd
          ? <Badge>Until {formatDateToDayMonth(currentPeriodEnd)}</Badge>
          : <Badge>Active</Badge>;

      case "PAST_DUE":
      case "INCOMPLETE":
      case "INCOMPLETE_EXPIRED":
      case "UNPAID":
        return <RedBadge>Payment Issue</RedBadge>;

      case "CANCELED":
        return <Badge>Canceled</Badge>;

      default:
        return "";
    }
  };

  return (
    <>{renderBadge()}</>
  );
}



const Badge = styled.span`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.color_Gray_01};
  border-radius: 2px;
  padding: 2.5px 7px 2.5px 6px;
  margin-left: 8px;
  color: ${({ theme }) => theme.colors.color_Gray_06};
  ${({ theme }) => theme.typography.Body_04};
`

const RedBadge = styled(Badge)`
  background-color: ${({ theme }) => theme.colors.color_alert_red};
  color: ${({ theme }) => theme.colors.color_White};
`

const GreenBadge = styled(Badge)`
  background-color: ${({ theme }) => theme.colors.color_alert_green};
  color: ${({ theme }) => theme.colors.color_White};
`

export default SubscriptionBadge;